import React from 'react';
import classnames from 'classnames';
import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankOutlined from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import IndeterminateCheckBox from '@mui/icons-material/IndeterminateCheckBox';

import checkboxStyles from 'uikit/inputs/styles/uikitInputsCheckbox.module.scss';
import styles from '../styles/threeStateCheckbox.module.scss';

const renderIcon = (value) => {
  if (value) {
    return <CheckBox className={styles.icon} sx={{ height: 18, width: 18 }} />;
  }

  if (value === null) {
    return <IndeterminateCheckBox className={styles.icon} sx={{ height: 18, width: 18 }} />;
  }

  return <CheckBoxOutlineBlankOutlined className={styles.icon} sx={{ height: 18, width: 18 }} />;
};

const ThreeStateCheckbox = ({ id, onChange, value }) => (
  <div
    className={classnames(styles.element, checkboxStyles.icon, {
      [styles.isActive]: value === true || value === null,
    })}
  >
    <input
      className={classnames(styles.input, checkboxStyles.input)}
      id={id}
      checked={Boolean(value)}
      onChange={(event) => onChange(event.target.checked)}
      type="checkbox"
    />
    {renderIcon(value)}
  </div>
);

export default React.memo(ThreeStateCheckbox);
